/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = --All Types--

1 = Selection

2 = Change Order

3 = Purchase Order

4 = Warranty

5 = Bid

6 = Daily Log

7 = Schedule Item

8 = To-Do

9 = Invoice

11 = Document

12 = Video

13 = Bill

14 = Photo

15 = Bid Package

16 = Credit Memo

17 = Receipt

18 = Bill

19 = Jobsite

20 = Deposit

21 = Chat

22 = Client Update

23 = Task

24 = Specification

25 = Plan Page

26 = Selection Options


 */
export type LinkedTypes = (typeof LinkedTypes)[keyof typeof LinkedTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LinkedTypes = {
  All: 0,
  Selections: 1,
  ChangeOrders: 2,
  PurchaseOrders: 3,
  Warranty: 4,
  Bids: 5,
  DailyLogs: 6,
  ScheduleItems: 7,
  ToDos: 8,
  OwnerPayments: 9,
  Documents: 11,
  Videos: 12,
  LegacyBills: 13,
  PhotoDocs: 14,
  BidPackages: 15,
  CreditMemo: 16,
  Receipts: 17,
  Bills: 18,
  Jobsite: 19,
  Deposit: 20,
  Chat: 21,
  ClientUpdate: 22,
  Task: 23,
  Specification: 24,
  PlanPage: 25,
  SelectionOptions: 26,
} as const;
